import { VStack, ButtonProps, LinkProps } from "@chakra-ui/react";
import { FC, isValidElement } from "react";
import { BlockContainer, IconBox } from "src/atoms";

import { heading2 } from "src/lib/renderer/elements/headings";
import { Element } from "@prismicio/react";
import { hyperlink } from "src/lib/renderer/elements/hyperlink";
import Renderer from "src/lib/renderer";
import { SvgOrImg } from "src/components/SvgOrImg";

import { getBackgroundColor } from "./utils";
import paragraph from "src/lib/renderer/elements/paragraph";

const BlockCenter: FC<Gatsby.PageBlockCenterFragment> = ({ primary }) => {
  if (!primary) throw Error();

  const { background_color, content, icon } = primary;

  const isLightGreyVariant =
    background_color === "light grey" ||
    background_color === "white" ||
    background_color === "red";

  return (
    <BlockContainer>
      <VStack
        bg={getBackgroundColor(background_color!)}
        borderRadius="intermediate"
        paddingX={{ base: "space-24", md: "space-80" }}
        paddingY="space-80"
        spacing="space-32"
        w="full"
        sx={{
          "> *": {
            color: isLightGreyVariant ? "text-primary" : "white",
            maxWidth: "800px",
          },
          h2: {
            color: isLightGreyVariant ? "text-heading" : "white",
            marginBottom: 0,
          },
          a: {
            color: isLightGreyVariant ? "btn-green-bg" : "white",
          },
        }}
      >
        <IconBox bg="white" borderRadius="intermediate">
          <SvgOrImg
            imageFile={icon?.document?.data?.image_file}
            isBox={true}
            size={24}
          />
        </IconBox>
        <Renderer
          overrides={{
            [Element.heading2]: (args) =>
              heading2({
                ...args,
                overrideProps: {
                  variant: "heading-3",
                },
              }),
            [Element.paragraph]: (args) =>
              paragraph({
                ...args,
                overrideProps: {
                  // variant: isLightGreyVariant ? "body-md-reg" : "body-lg-med",
                  variant: "body-md-reg",
                },
              }),
            [Element.hyperlink]: (args) => {
              let overrideProps: ButtonProps & LinkProps = {
                variant: "tertiary",
              };

              const isPrimaryButton = args?.children.some(
                (child) =>
                  isValidElement(child) &&
                  child.props.className === "button-tertiary", // changing the className from "btn-primary" to "button-tertiary" to follow the reskin design. Will have to disable the ability to select the other btn variant in Prismic to avoid confusion
              );

              if (isPrimaryButton) {
                overrideProps = {
                  ...overrideProps,
                  variant: "tertiary", // changing the variant tertiary to follow the reskin design. Will have to disable the ability to select the other btn variant in Prismic to avoid confusion
                };
              }

              return hyperlink({
                ...args,
                overrideProps: { ...overrideProps },
              });
            },
          }}
          field={content}
        />
      </VStack>
    </BlockContainer>
  );
};

export default BlockCenter;
